var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h1',{staticClass:"mt-6 mb-6"},[_vm._v(" Cameras ")]),_c('v-data-table',{staticClass:"row-pointer elevation-1",attrs:{"items":_vm.cameras,"headers":_vm.headers,"loading":_vm.loading},on:{"click:row":_vm.clickCamera}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }